export default {
  data() {
    return {
      homeColumnConfig: [
        {
          label: '序号',
          align: 'center',
          fixed: 'left',
          render: (h, scope) => {
            return <span slot="reference">{scope.$index * 1 + 1}</span>
          },
        },

        { label: '医院编号', align: 'center', prop: 'code' },
        {
          label: '医院名称',
          align: 'center',
          prop: 'name',
        },
        { label: '医院简称', align: 'center', prop: 'shortName' },
        {
          label: '医院类型',
          align: 'center',
          prop: 'orgTypeDisplayAs',
        },

        { label: '业务分类', align: 'center', prop: 'businessTypeDisplayAs' },
        {
          label: '状态',
          align: 'center',
          prop: 'disabled',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.disabled ? '已禁用' : '已启用'}</span>
          },
        },
        {
          label: '修改人',
          align: 'center',
          prop: 'updateUserId',
        },
        {
          label: '修改时间',
          align: 'center',
          prop: 'updateTime',
        },
        {
          label: '医院等级',
          align: 'center',
          prop: 'levelDisplayAs',
        },
        {
          label: '医院说明',
          align: 'center',
          render: (h, scope) => {
            return (
              <div>
                <el-popover popper-class="popper" trigger="hover">
                  <div slot="reference" style="height: 46px; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;">{scope.row.description}</div>
                  <div style="height:100px">
                    <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;">{scope.row.description}</el-scrollbar>
                  </div>
                </el-popover>
              </div>
            )
          },
        },
        // {
        //   props:{ placement="center" ,width="400",trigger="hover"}
        // },123
        {
          label: '操作',
          align: 'center',
          fixed: 'right',
          width: '200px',
          render: (h, scope) => {
            return (
              <div>
                <el-button size="mini" type="text" onClick={() => this.hometHandelDetails(scope)}>
                  详情
                </el-button>
                <el-button size="mini" type="text" onClick={() => this.$router.push({path:'/Organization/department',query:{id:scope.row.id,type:'open'}})}>
                  科室
                </el-button>
                <el-button size="mini" type="text" onClick={() => this.$router.push({path:'/Organization/medicalinfo',query:{id:scope.row.id}})}>
                  医护
                </el-button>
                <el-button size="mini" type="text" onClick={() => this.disableHandel(scope)}>
                  { scope.row.disabled ? '启用' : '禁用'}
                </el-button>
              </div>
            )
          },
        },
      ],
      addFormRules:{
        name:[
          { required: true, message: '请输入机构名称', trigger: 'blur' },
          { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' },
        ],
        shortName:[
          { required: true, message: '请输入医院简称', trigger: 'blur' },
          { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' },
        ],
        orgType:[
          { required: true, message: '请选择医院类型', trigger: 'change' }
        ],
        level:[
          { required: true, message: '请选择医院等级', trigger: 'change' }
        ],
		
        businessType:[
          { required: true, message: '请选择业务分类', trigger: 'change' }
        ],
        hospitalId:[
          { required: true, message: '请选择依托实体医院', trigger: 'change' }
        ],
        cityList:[
          { required: true, message: '请选择所属区域', trigger: 'change' }
        ],
        longitude:[
          { required: true, message: '请输入经度', trigger: 'change' }
        ],
        latitude:[
          { required: true, message: '请输入纬度', trigger: 'change' }
        ],
       
        address:[
          { required: true, message: '请输入详细机构地址', trigger: 'blur' },
          { min: 2, max: 500, message: '长度在 2 到 500 个字符', trigger: 'blur' },
        ],
        description:[
          { required: true, message: '请输入医院简介', trigger: 'blur' },
          { min: 2, max: 500, message: '长度在 2 到 500 个字符', trigger: 'blur' },
        ]
      }
    }
  },
}
